import pluralize from 'pluralize';

import { type WorkspaceAgentThumbnail } from '~/components/v2/components/workspace/workspace-agent-panel/design-system/cards/workspaceAgentThumbnailTypes';
import {
  getWorkspaceAgentGuidedVariantSkipKind,
  type WorkspaceAgentGuidedVariantSkipKind,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/getWorkspaceAgentGuidedVariantSkipCounts';

type WorkspaceAgentUncitedScopeCountNoun = WorkspaceAgentGuidedVariantSkipKind | 'item';

/**
 * Homogeneous image / video / file sets use that noun; mixed or unresolved types read as "items".
 * Clip taxonomy matches `getWorkspaceAgentGuidedVariantSkipKind` (all `ClipType`s + document `ext` on photo clips).
 */
const getWorkspaceAgentUncitedScopeCountNoun = (
  thumbnails: readonly WorkspaceAgentThumbnail[],
): WorkspaceAgentUncitedScopeCountNoun => {
  let kind: WorkspaceAgentGuidedVariantSkipKind | null = null;

  for (const thumbnail of thumbnails) {
    if (thumbnail.type == null) {
      return 'item';
    }

    const thumbnailKind = getWorkspaceAgentGuidedVariantSkipKind({
      ext: thumbnail.ext,
      type: thumbnail.type,
    });

    if (kind === null) {
      kind = thumbnailKind;
      continue;
    }

    if (kind !== thumbnailKind) {
      return 'item';
    }
  }

  return kind ?? 'item';
};

export const getWorkspaceAgentUncitedScopeCountLabel = (
  count: number,
  thumbnails: readonly WorkspaceAgentThumbnail[],
): string => `${count.toLocaleString()} ${pluralize(getWorkspaceAgentUncitedScopeCountNoun(thumbnails), count)}`;
